<template>
	<v-spinner :size="20" color="--input-border-color-hover" />
</template>

<script>
export default {
	name: 'VExtDisplayLoading'
};
</script>
